/**
 * Helpers for Area Calculations
 */

/**
 * Calculates the area in m2 and pie2 based on width, height, quantity and waste factor.
 * Formulas:
 * Area (Pie 2) = ((x + 2Z) * (y + 2Z)) / 929.0304
 * Area (m2)    = ((x + 2Z) / 100) * ((y + 2Z) / 100)
 * 
 * @param {Object} row - Measurement row containing {ancho, alto, cantidad}
 * @param {Number|String} factorDesperdicio - Waste factor per side
 * @returns {Object} - { areaM2, areaPie2 } total for the given quantity
 */
/**
 * Calculates the area in Square Meters (m2)
 * Formula: Area (m2) = ((x + 2Z) / 100) * ((y + 2Z) / 100)
 */
export const calculateAreaM2 = (row, factorDesperdicio) => {
    const x = parseFloat(row.ancho) || 0;
    const y = parseFloat(row.alto) || 0;
    const z = parseFloat(factorDesperdicio) || 0;
    const cant = parseFloat(row.cantidad) || 0;
    
    if (x === 0 || y === 0) return 0;
    
    const area = ((x + 2 * z) / 100) * ((y + 2 * z) / 100);
    const totalArea = area * cant;
    console.log(`[AreaCalculations - M2] Ancho(x):${x}, Alto(y):${y}, Factor(z):${z}, Cant:${cant} => Area Unitaria: ${area}, Total: ${totalArea}`);
    return totalArea;
};

/**
 * Calculates the area in Square Feet (Pie2)
 * Formula: Area (Pie 2) = ((x + 2Z) * (y + 2Z)) / 929.0304
 */
export const calculateAreaPie2 = (row, factorDesperdicio) => {
    const x = parseFloat(row.ancho) || 0;
    const y = parseFloat(row.alto) || 0;
    const z = parseFloat(factorDesperdicio) || 0;
    const cant = parseFloat(row.cantidad) || 0;
    
    if (x === 0 || y === 0) return 0;
    
    const area = ((x + 2 * z) * (y + 2 * z)) / 929.0304;
    const totalArea = area * cant;
    console.log(`[AreaCalculations - Pie2] Ancho(x):${x}, Alto(y):${y}, Factor(z):${z}, Cant:${cant} => Area Unitaria: ${area}, Total: ${totalArea}`);
    return totalArea;
};

/**
 * Calculates the waste area in Square Meters (m2)
 * Formula: Waste = CalculatedArea - NetArea
 * NetArea (m2) = (x / 100) * (y / 100)
 */
export const calculateWasteM2 = (row, factorDesperdicio) => {
    const x = parseFloat(row.ancho) || 0;
    const y = parseFloat(row.alto) || 0;
    const cant = parseFloat(row.cantidad) || 0;
    
    if (x === 0 || y === 0) return 0;
    
    const calculatedAreaM2 = calculateAreaM2(row, factorDesperdicio); // Includes quantity
    const netAreaM2 = ((x / 100) * (y / 100)) * cant;
    const waste = calculatedAreaM2 - netAreaM2;
    console.log(`[AreaCalculations - Waste M2] AreaCalculada:${calculatedAreaM2} - AreaNeta:${netAreaM2} => Desperdicio: ${waste}`);
    return waste;
};

/**
 * Calculates the waste area in Square Feet (Pie2)
 * Formula: Waste = CalculatedArea - NetArea
 * NetArea (Pie2) = (x * y) / 929.0304
 */
export const calculateWastePie2 = (row, factorDesperdicio) => {
    const x = parseFloat(row.ancho) || 0;
    const y = parseFloat(row.alto) || 0;
    const cant = parseFloat(row.cantidad) || 0;
    
    if (x === 0 || y === 0) return 0;
    
    const calculatedAreaPie2 = calculateAreaPie2(row, factorDesperdicio); // Includes quantity
    const netAreaPie2 = ((x * y) / 929.0304) * cant;
    const waste = calculatedAreaPie2 - netAreaPie2;
    console.log(`[AreaCalculations - Waste Pie2] AreaCalculada:${calculatedAreaPie2} - AreaNeta:${netAreaPie2} => Desperdicio: ${waste}`);
    return waste;
};
